import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ca-compact-form-spacer',
    templateUrl: './compact-form-spacer.component.html',
    styleUrls: ['./compact-form-spacer.component.scss'],
    standalone: false
})
export class CompactFormSpacerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
